<template>
  <v-dialog v-model="add_modal" max-width="1300" persistent>
    <v-card :loading="loading">
      <v-card-title>
        <v-col cols="2">Add Project</v-col>
        <v-col
          cols="10"
          class="text-end"
        >{{form_data.project_work=='new_construction' ? 'New Construction' : form_data.project_work=='remodeling' ? 'Remodeling' : form_data.project_work=='retail_sales' ? 'General Invoice' : form_data.project_work=='counter_tops' ? 'Counter Tops' : '' }}</v-col>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-row dense class="mb-2 grey lighten-2 pt-2 pb-1">
            <v-col cols="1" style="max-width: 10%;">
              <v-text-field
                label="Order No"
                dense
                v-model="form_data.project_id"
                hide-details
                readonly
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col cols="2" style="max-width: 17%;">
              <v-menu
                v-model="display_date"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form_data.display_date"
                    label="Order Date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    hint="MM/DD/YYYY format"
                    placeholder=" "
                    :error-messages="form_error.display_date"
                    :hide-details="!form_error.display_date"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateFormattedDisplay"
                  @input="display_date = false; parseDateDisplay()"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="2" style="max-width: 17%;">
              <v-menu
                v-model="estimated_completed_date"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form_data.estimated_completed_date"
                    label="Est. Comp. Dt"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    placeholder=" "
                    :error-messages="form_error.estimated_completed_date"
                    :hide-details="!form_error.estimated_completed_date"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateFormatted"
                  @input="estimated_completed_date = false; parseDate()"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col style="max-width: 14%;">
              <v-select
                :items="order_types"
                label="Status"
                dense
                v-model="form_data.order_type"
                :error-messages="form_error.order_type"
                :hide-details="!form_error.order_type"
                placeholder=" "
              ></v-select>
              <!-- <v-radio-group
                v-model="form_data.order_type"
                row
                hide-details
                class="mt-0"
                dense=""
              >
                <v-radio
                  label="Estimate"
                  value="2"
                  class="ma-0 pa-0 pl-1"
                ></v-radio>
                <v-radio
                  label="Order"
                  value="1"
                  class="ma-0 pa-0"
                ></v-radio>
              </v-radio-group>-->
            </v-col>
            <v-col style="max-width: 14%;">
              <v-text-field
                label="Order Amount"
                dense
                v-model="form_data.transactoin_amount"
                :error-messages="form_error.transactoin_amount"
                :hide-details="!form_error.transactoin_amount"
                readonly
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col style="max-width: 14%;">
              <v-select
                :items="p_type"
                label="Order Type"
                dense
                v-model="form_data.p_type"
                :error-messages="form_error.p_type"
                :hide-details="!form_error.p_type"
                placeholder=" "
                :disabled="form_data.project_work=='project_management'"
              ></v-select>
            </v-col>
            <v-col style="max-width: 14%;">
              <v-text-field
                label="Overhead & Profit %"
                dense
                type="number"
                v-model="form_data.p_price"
                :error-messages="form_error.p_price"
                :hide-details="!form_error.p_price"
                placeholder=" "
                :disabled="form_data.p_lock"
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="1" style="min-width: 14%;">
              <v-autocomplete
                dense
                label="Assign To"
                v-model="form_data.assign_to"
                :items="users"
                :error-messages="form_error.assign_to"
                :hide-details="!form_error.assign_to"
                item-text="full_name"
                item-value="user_id"
                placeholder=" "
              >
                <template v-slot:no-data>
                    <div class="d-flex align-center">
                      <span
                        class="pl-2"
                        style="
                          font-size: 0.8125rem;
                          font-weight: 500;
                          line-height: 1rem;
                        "
                        >No User Found!</span
                      >
                      <span
                        @click="addUser"
                        class="mdi mdi-plus-circle pl-1 pr-2"
                        style="
                          font-size: 1.5rem;
                          cursor: pointer;
                          color: #6e9a35 !important;
                        "
                      ></span>
                    </div>
                </template>
              </v-autocomplete>
            </v-col>-->
            <!-- <v-col>
              <v-autocomplete
                dense
                label="Access To"
                v-model="form_data.access_to"
                :items="sort_list"
                :error-messages="form_error.access_to"
                :hide-details="!form_error.access_to"
                item-text="full_name"
                item-value="user_id"
                multiple=""
                placeholder=" "
              >
                <template v-slot:selection="{ index }">
                  <span class="grey--text caption" v-if="index == 0">
                    {{selected_multi_values}}
                  </span>
                </template>
                <template v-slot:no-data>
                    <div class="d-flex align-center">
                      <span
                        class="pl-2"
                        style="
                          font-size: 0.8125rem;
                          font-weight: 500;
                          line-height: 1rem;
                        "
                        >No User Found!</span
                      >
                      <span
                        @click="addUser"
                        class="mdi mdi-plus-circle pl-1 pr-2"
                        style="
                          font-size: 1.5rem;
                          cursor: pointer;
                          color: #6e9a35 !important;
                        "
                      ></span>
                    </div>
                </template>
              </v-autocomplete>
            </v-col>-->
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="5">
              <v-autocomplete
                dense
                label="Customer"
                v-model="form_data.customer_id"
                :items="customer_list"
                :error-messages="form_error.customer_id"
                :hide-details="!form_error.customer_id"
                item-text="full_name"
                item-value="customer_id"
                autofocus
                @change="changeCustomer()"
              >
                <template v-slot:no-data>
                  <div class="d-flex align-center">
                    <span
                      class="pl-2"
                      style="
                          font-size: 0.8125rem;
                          font-weight: 500;
                          line-height: 1rem;
                        "
                    >No Customer Found!</span>
                    <span
                      @click="addCustomer"
                      class="mdi mdi-plus-circle pl-1 pr-2"
                      style="
                          font-size: 1.5rem;
                          cursor: pointer;
                          color: #6e9a35 !important;
                        "
                    ></span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-text-field
                v-model="form_data.multiplier"
                label="Multiplier"
                dense
                hide-details
                :disabled="form_data.p_lock"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="3">
              <v-text-field
                label="Project name"
                dense
                v-model="form_data.p_name"
                :error-messages="form_error.p_name"
                :hide-details="!form_error.p_name"
                @keyup="getShortCode()"
              ></v-text-field>
            </v-col>

            <v-col class="d-flex justify-end">
              <label class="v-label theme--light mt-3 mr-2">Lock</label>
              <v-switch
                v-model="form_data.p_lock"
                label
                color="success"
                hide-details
                class="mt-1"
                dense
              ></v-switch>
            </v-col>
            <v-col class="d-flex justify-end">
              <label class="v-label theme--light mt-3 mr-2">Active</label>
              <v-switch
                v-model="form_data.p_active"
                label
                color="success"
                hide-details
                class="mt-1"
                dense
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="2">
              <v-autocomplete
                label="Zip"
                dense
                v-model="form_data.p_zip"
                :error-messages="form_error.p_zip"
                :search-input.sync="zip_search"
                :items="zip_items"
                :hide-details="!form_error.p_zip"
                v-debounce:500="fetchZipCodes"
                :menu-props="{closeOnContentClick:true}"
                :loading="zip_loading"
                @change="getStates(false)"
              >
                <template v-slot:no-data v-if="zip_search">
                  <div class="d-flex align-center">
                    <span
                      class="pl-2"
                      style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                    >No Zip Found!</span>
                    <span
                      @click="addZip"
                      class="mdi mdi-plus-circle pl-1 pr-2"
                      style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                    ></span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-select
                :items="state_list"
                label="State"
                dense
                v-model="form_data.p_state"
                @change="getCity()"
                hide-details
              >
                <template v-slot:selection="{ item }">
                  <span>{{ item.short_name }}</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                :items="cities"
                label="City"
                dense
                class="capitalize-first-letter"
                v-model="form_data.p_city"
                @change="changeCity()"
                :search-input.sync="city_search"
                :menu-props="{closeOnContentClick:true}"
                :error-messages="form_error.p_city"
                :hide-details="!form_error.p_city"
              >
                <template v-slot:no-data v-if="city_search">
                  <div class="d-flex align-center">
                    <span
                      class="pl-2"
                      style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                    >No City Found!</span>
                    <span
                      @click="addCity"
                      class="mdi mdi-plus-circle pl-1 pr-2"
                      style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                    ></span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Mobile"
                dense
                v-model="form_data.mobile"
                :error-messages="form_error.mobile"
                :hide-details="!form_error.mobile"
                v-mask="'(###)-###-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="2" style="max-width: 9%;">
              <v-text-field
                label="Short Code"
                dense
                v-model="form_data.p_code"
                v-mask="'XXXXXXX'"
                :error-messages="form_error.p_code"
                :hide-details="!form_error.p_code"
                class="capitalize-whole-letter"
              ></v-text-field>
            </v-col>
            <v-col cols="2" v-if="form_data.is_retainage" style="max-width: 9%;margin-left:30px;">
              <v-text-field
                label="Retainage %"
                dense
                v-model="form_data.retainage_percentage"
                :error-messages="form_error.retainage_percentage"
                :hide-details="!form_error.retainage_percentage"
                type="number"
                :disabled="form_data.p_lock"
              ></v-text-field>
            </v-col>
            <v-col class="d-flex justify-end">
              <label class="v-label theme--light mt-3 mr-2">Retainage</label>
              <v-switch
                v-model="form_data.is_retainage"
                label
                color="success"
                hide-details
                class="mt-1"
                dense
                :disabled="form_data.p_lock"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="6">
              <v-text-field
                label="Street Address(Project Address)"
                class="capitalize-first-letter"
                dense
                v-model="form_data.p_address_1"
                :error-messages="form_error.p_address_1"
                :hide-details="!form_error.p_address_1"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Office"
                dense
                v-model="form_data.work_phone"
                :error-messages="form_error.work_phone"
                :hide-details="!form_error.work_phone"
                v-mask="'(###)-###-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="3" style="max-width: 20%;" class="d-flex justify-end">
              <label class="v-label theme--light mt-3 mr-2">Order Confirmed</label>
              <v-switch
                v-model="form_data.order_confirmed"
                label
                color="success"
                hide-details
                class="mt-1"
                dense
              ></v-switch>
            </v-col>
            <v-col class="d-flex justify-end">
              <label class="v-label theme--light mt-3 mr-2">Text Alert</label>
              <v-switch
                v-model="form_data.text_alert"
                label
                color="success"
                hide-details
                class="mt-1"
                dense
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="6">
              <v-text-field
                label="Street Address(Project Address)"
                class="capitalize-first-letter"
                dense
                v-model="form_data.p_address_2"
                :error-messages="form_error.p_address_2"
                :hide-details="!form_error.p_address_2"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Fax"
                dense
                v-model="form_data.work_fax"
                :error-messages="form_error.work_fax"
                :hide-details="!form_error.work_fax"
                v-mask="'(###)-###-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="3" style="max-width: 20%;" class="d-flex justify-end">
              <label class="v-label theme--light mt-3 mr-2">Profit & Loss</label>
              <v-switch
                v-model="form_data.profit_loss"
                label
                color="success"
                hide-details
                class="mt-1"
                dense
              ></v-switch>
            </v-col>
            <v-col class="d-flex justify-end">
              <label class="v-label theme--light mt-3 mr-2">Email Alert</label>
              <v-switch
                v-model="form_data.email_alert"
                label
                color="success"
                hide-details
                class="mt-1"
                dense
              ></v-switch>
            </v-col>
          </v-row>

          <v-row dense class="mb-0">
            <v-col cols="3">
              <v-text-field
                label="Bill To"
                class="capitalize-first-letter"
                dense
                v-model="form_data.bill_to"
                :error-messages="form_error.bill_to"
                :hide-details="!form_error.bill_to"
                loading
              >
                <template v-slot:progress>
                  <v-progress-linear value="100" absolute height="2" class="primary"></v-progress-linear>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-checkbox
                dense
                hide-details
                v-model="is_same_address"
                label="Same as above address"
                class="pa-0 ma-0 mt-1"
                @change="sameAsAbove()"
              ></v-checkbox>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Email"
                dense
                v-model="form_data.bill_to_email"
                :error-messages="form_error.bill_to_email"
                :hide-details="!form_error.bill_to_email"
                reverse
              ></v-text-field>
            </v-col>
            <v-col>
              <v-autocomplete
                prepend-icon="mdi-at"
                :items="domain_list"
                label="Domain"
                dense
                v-model="form_data.bill_to_email_domain"
                :error-messages="form_error.bill_to_email_domain"
                :hide-details="!form_error.bill_to_email_domain"
                :search-input.sync="domain_search"
                :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data>
                  <div class="d-flex align-center">
                    <span
                      class="pl-2"
                      style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                    >No Domain Found!</span>
                    <span
                      @click="addDomain"
                      class="mdi mdi-plus-circle pl-1 pr-2"
                      style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                    ></span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row dense class="mb-0">
            <v-col cols="2">
              <v-autocomplete
                label="Zip"
                dense
                v-model="form_data.bill_to_zip"
                :error-messages="form_error.bill_to_zip"
                :search-input.sync="bill_zip_search"
                :items="bill_zip_items"
                :hide-details="!form_error.bill_to_zip"
                v-debounce:500="fetchBZipCodes"
                :loading="bill_zip_loading"
                :menu-props="{closeOnContentClick:true}"
                @change="getStates(true)"
              >
                <template v-slot:no-data v-if="bill_zip_search">
                  <div class="d-flex align-center">
                    <span
                      class="pl-2"
                      style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                    >No Zip Found!</span>
                    <span
                      @click="addZip2"
                      class="mdi mdi-plus-circle pl-1 pr-2"
                      style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                    ></span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-select
                :items="state_list"
                label="State"
                dense
                v-model="form_data.bill_to_state"
                @change="getCity2()"
                hide-details
              >
                <template v-slot:selection="{ item }">
                  <span>{{ item.short_name }}</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                :items="bill_cities"
                label="City"
                class="capitalize-first-letter"
                dense
                v-model="form_data.bill_to_city"
                @change="changeCity2()"
                :search-input.sync="bill_to_city_search"
                :menu-props="{closeOnContentClick:true}"
                :error-messages="form_error.bill_to_city"
                :hide-details="!form_error.bill_to_city"
              >
                <template v-slot:no-data v-if="bill_to_city_search">
                  <div class="d-flex align-center">
                    <span
                      class="pl-2"
                      style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                    >No City Found!</span>
                    <span
                      @click="addCity2"
                      class="mdi mdi-plus-circle pl-1 pr-2"
                      style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                    ></span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="4" class="mt-0 pt-0 mb-0 pb-0">
              <v-text-field
                label="Architect Name"
                class="capitalize-first-letter"
                dense
                v-model="form_data.architect_name"
                :error-messages="form_error.architect_name"
                :hide-details="!form_error.architect_name"
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="5" class="mt-0 pt-0 mb-0 pb-0">
              <v-row dense="">
                <v-col cols="5" class="mt-0 pt-0 mb-0 pb-0">
                  <v-card 
                  class="pa-0 ma-0"
                  rounded="0"
                  flat>
                    <v-row dense="">
                      <v-col cols="2">
                        <v-radio-group v-model="form_data.project_work" hide-details class="pa-0 ma-0">
                          <v-radio
                            value="new_construction"
                            class="pa-0 ma-0 mt-1"
                            checked
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="10">
                        <v-card-subtitle class="custome-label-font pa-0 ma-0 pl-1">
                          New Construction
                        </v-card-subtitle>
                        <v-card-text class="primary text-center white--text custome-value-font pa-0 ma-0 pt-1 pb-1 pl-1">
                          <p class="mb-3"></p>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="5" class="mt-0 pt-0 mb-0 pb-0">
                  <v-card 
                  class="pa-0 ma-0"
                  rounded="0"
                  flat>
                    <v-row dense="">
                      <v-col cols="2">
                        <v-radio-group v-model="form_data.project_work" hide-details class="pa-0 ma-0">
                          <v-radio
                            value="remodeling"
                            class="pa-0 ma-0 mt-1"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="10">
                        <v-card-subtitle class="custome-label-font pa-0 ma-0 pl-1">
                          Remodeling
                        </v-card-subtitle>
                        <v-card-text class="primary text-center white--text custome-value-font pa-0 ma-0 pt-1 pb-1 pl-1">
                          <p class="mb-3"></p>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>-->
          </v-row>

          <v-row dense class="mb-0">
            <v-col cols="6">
              <v-text-field
                label="Street Address"
                class="capitalize-first-letter"
                dense
                v-model="form_data.bill_to_address_1"
                :error-messages="form_error.bill_to_address_1"
                :hide-details="!form_error.bill_to_address_1"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <!-- <v-col cols="5" class="mt-0 pt-0 mb-0 pb-0">
              <v-row dense>
                <v-col cols="5" class="mt-0 pt-0 mb-0 pb-0">
                  <v-card 
                  class="pa-0 ma-0"
                  rounded="0"
                  flat>
                    <v-row dense="">
                      <v-col cols="2">
                        <v-radio-group v-model="form_data.project_work" hide-details class="pa-0 ma-0">
                          <v-radio
                            value="retail_sales"
                            class="pa-0 ma-0 mt-1"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="10">
                        <v-card-subtitle class="custome-label-font pa-0 ma-0 pl-1">
                          General Invoice
                        </v-card-subtitle>
                        <v-card-text class="primary text-center white--text custome-value-font pa-0 ma-0 pt-1 pb-1 pl-1">
                          <p class="mb-3"></p>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col cols="5" class="mt-0 pt-0 mb-0 pb-0">
                  <v-card 
                  class="pa-0 ma-0"
                  rounded="0"
                  flat>
                    <v-row dense="">
                      <v-col cols="2">
                        <v-radio-group v-model="form_data.project_work" hide-details class="pa-0 ma-0">
                          <v-radio
                            value="counter_tops"
                            class="pa-0 ma-0 mt-1"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="10">
                        <v-card-subtitle class="custome-label-font pa-0 ma-0 pl-1">
                          Counter Tops
                        </v-card-subtitle>
                        <v-card-text class="primary text-center white--text custome-value-font pa-0 ma-0 pt-1 pb-1 pl-1">
                          <p class="mb-3"></p>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>-->
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="6">
              <v-text-field
                label="Street Address"
                class="capitalize-first-letter"
                dense
                v-model="form_data.bill_to_address_2"
                :error-messages="form_error.bill_to_address_2"
                :hide-details="!form_error.bill_to_address_2"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="5" class="mt-0 pt-0 mb-0 pb-0">
              <v-row dense>
                <v-col cols="5" class="mt-0 pt-0 mb-0 pb-0">
                  <!-- <v-btn block small class="primary text-capitalize">Project Management</v-btn> -->
                  <!-- <v-card 
                  class="pa-0 ma-0"
                  rounded="0"
                  flat>
                    <v-row dense="">
                      <v-col cols="2">
                        <v-radio-group v-model="form_data.project_work" hide-details class="pa-0 ma-0">
                          <v-radio
                            value="project_management"
                            class="pa-0 ma-0 mt-1"
                            @click="disabledTypeValue()"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="10">
                        <v-card-subtitle class="custome-label-font pa-0 ma-0 pl-1">
                          Project Management
                        </v-card-subtitle>
                        <v-card-text class="primary text-center white--text custome-value-font pa-0 ma-0 pt-1 pb-1 pl-1">
                          <p class="mb-3"></p>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>-->
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="1">
              <v-text-field
                label="MMS Code"
                dense
                v-model="form_data.mms_code"
                :error-messages="form_error.mms_code"
                :hide-details="!form_error.mms_code"
              ></v-text-field>
            </v-col>
            <v-col cols="5">
              <v-text-field
                v-model="form_data.keywords"
                label="Keywords (comma sperated)"
                dense
                :error-messages="form_error.keywords"
                :hide-details="!form_error.keywords"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="5" class="mt-0 pt-0 mb-0 pb-0">
              <v-row dense></v-row>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="6"></v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="1"></v-col>
            <v-col cols="2" class="mt-0 pt-0 mb-0 pb-0"></v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="saveProject()" :loading="loading">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import axios from "../../plugins/axios";
import { FLORIDA_STATE } from "../../plugins/global_names";
const moment = require("moment");
export default {
  name: "ProjectAdd",
  data() {
    return {
      loading: false,
      customer_multiplier: "",
      form_data: {
        p_active: true,
        is_retainage: false,
        p_lock: false,
        order_type: "2",
        text_alert: false,
        email_alert: false,
        profit_loss: true,
        project_work: "new_construction",
        p_price: "20",
        p_type: "fixed",
        bill_to_address_1: null,
        bill_to_address_2: null,
        multiplier: "1.0",
        order_confirmed: false,
        display_date: null
      },
      estimated_completed_date: false,
      display_date: false,
      bill_to_city_search: null,
      city_search: null,
      domain_search: null,
      users: [],
      state_list: [],
      customer_list: [],
      domain_list: [],
      cities: [],
      bill_cities: [],
      form_error: {},
      zip_search: null,
      zip_loading: false,
      bill_zip_loading: false,
      bill_zip_items: [],
      bill_zip_search: null,
      new_zip_id: null,
      new_zip_id2: null,
      is_same_address: false,
      zip_items: [],
      dateFormatted: null,
      dateFormattedDisplay: null,
      last_project_no: "",
      p_hold: [
        { text: "Yes", value: "yes" },
        { text: "No", value: "no" },
        { text: "Auto Freeze", value: "auto_freeze" }
      ],
      p_type: [
        { text: "Fixed Price", value: "fixed" },
        { text: "Cost Plus", value: "cost_plus" }
        // { text: "Project Management", value: "project_management" },
      ],
      order_types: [
        { text: "Order", value: "1" },
        { text: "Estimate", value: "2" }
        // { text: "EstToOrd", value: "3" },
        // { text: "Outstading", value: "4" },
        // { text: "Open Orders", value: "5" },
        // { text: "Canceled Estimates", value: "6" },
        // { text: "Canceled Orders", value: "7" },
        // { text: "Customer Refund", value: "8" },
      ]
    };
  },
  props: ["project_type"],
  watch: {
    add_modal: {
      handler(val) {
        if (val) {
          this.getNextProject();
          this.getInitalStates();
          this.getCustomers();
          this.getEmailDomains();
          this.getCity();
          this.getCity2();
          this.getUsers();

          this.customer_multiplier = "";
          this.form_data = {
            p_active: true,
            is_retainage: false,
            p_lock: false,
            order_type: "2",
            text_alert: false,
            email_alert: false,
            profit_loss: true,
            project_work:
              this.project_type == 1
                ? "new_construction"
                : this.project_type == 2
                ? "remodeling"
                : this.project_type == 3
                ? "counter_tops"
                : this.project_type == 4
                ? "retail_sales"
                : "new_construction",
            p_price: "20",
            p_type: "fixed",
            bill_to_address_1: null,
            bill_to_address_2: null,
            multiplier: "1.0",
            display_date: moment().format("MM/DD/YYYY"),
            estimated_completed_date: moment()
              .add(6, "month")
              .calendar()
          };
        }
      }
    }
    // "form_data.p_zip": {
    //   handler() {
    //     this.getStates(false);
    //   },
    // },
    // "form_data.bill_to_zip": {
    //   handler() {
    //     this.getStates(true);
    //   },
    // },
  },

  computed: {
    ...mapState("project", ["add_modal"]),
    sort_list() {
      let selected_vendors = this.form_data.access_to;
      let vendors = this.users.filter(item => {
        if (selected_vendors) {
          if (!selected_vendors.includes(item.user_id)) {
            return item;
          }
        } else {
          return item;
        }
      });
      vendors = vendors.sort((a, b) => {
        let fa = a.full_name,
          fb = b.full_name;
        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });
      this.users.filter(item => {
        if (selected_vendors) {
          if (selected_vendors.includes(item.user_id)) {
            vendors.unshift(item);
          }
        }
      });
      return vendors;
    },
    selected_multi_values() {
      let return_data = "";
      if (this.form_data.access_to.length > 0) {
        this.users.filter(item => {
          if (item.user_id == this.form_data.access_to[0]) {
            return_data = item.full_name;
          }
        });
        if (this.form_data.access_to.length > 1) {
          let totalVen = this.form_data.access_to.length - 1;
          return_data = return_data + " (" + totalVen + " More)";
        }
      }
      return return_data;
    }
  },
  methods: {
    ...mapMutations("project", ["setData"]),
    parseDate() {
      const [year, month, day] = this.dateFormatted.split("-");
      this.form_data.estimated_completed_date = `${month.padStart(
        2,
        "0"
      )}/${day.padStart(2, "0")}/${year}`;
    },
    parseDateDisplay() {
      const [year, month, day] = this.dateFormattedDisplay.split("-");
      this.form_data.display_date = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },
    sameAsAbove() {
      if (this.is_same_address) {
        this.loading = true;
        this.bill_zip_items = this.zip_items;
        this.bill_cities = this.cities;
        this.form_data.bill_to_zip = this.form_data.p_zip;
        this.form_data.bill_to_state = this.form_data.p_state;
        this.form_data.bill_to_city = this.form_data.p_city;
        this.form_data.bill_to_address_1 = this.form_data.p_address_1;
        this.form_data.bill_to_address_2 = this.form_data.p_address_2;

        let selected_customer = this.customer_list.filter(item => {
          return item.customer_id == this.form_data.customer_id;
        })[0];
        if (selected_customer) {
          this.form_data.bill_to = selected_customer.full_name;
        } else {
          this.form_data.bill_to = "";
        }
        this.loading = false;
      }
    },
    getShortCode() {
      this.form_data.p_code = this.form_data.p_name
        .replace(/\s+/g, "")
        .substring(0, 7);
    },
    changeCustomer() {
      this.loading = true;
      let selected_customer = this.customer_list.filter(item => {
        return item.customer_id == this.form_data.customer_id;
      })[0];
      console.log(selected_customer, "selected_customer");
      this.customer_multiplier = selected_customer.multiplier;
      this.zip_search = selected_customer.zip;
      this.fetchZipCodes();
      if (selected_customer.state) {
        this.form_data.p_state = selected_customer.state.state_id;
        this.getCity();
      } else {
        this.form_data.p_state = null;
      }
      if (selected_customer.city) {
        this.form_data.p_city = selected_customer.city.city_id;
      } else {
        this.form_data.p_city = null;
      }
      this.form_data.p_address_1 = selected_customer.address_line_1;
      this.form_data.p_address_2 = selected_customer.address_line_2;
      this.form_data.mobile = selected_customer.mobile_number;
      this.form_data.work_phone = selected_customer.work_phone;
      this.form_data.work_fax = selected_customer.fax;
      this.form_data.p_zip = selected_customer.zip;
      this.form_data.bill_to_email = selected_customer.email;
      if (selected_customer.email_domain) {
        this.form_data.bill_to_email_domain =
          selected_customer.email_domain.domain_id;
      } else {
        this.form_data.bill_to_email_domain = null;
      }
      //this.form_data.bill_to = selected_customer.company_name
      this.loading = false;
    },
    addCity() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_city", {
          state_id: _self.form_data.p_state,
          city_name: _self.city_search
        })
        .then(function(res) {
          let data = res.data.data;
          if (res.data.status == true) {
            _self.cities.push({ value: data.value, text: data.text });
            _self.form_data.p_city = data.value;
            _self.changeCity();
            _self.loading = false;
          } else {
            _self.form_error.p_city = "City already exist";
            _self.loading = false;
          }
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    addCity2() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_city", {
          state_id: _self.form_data.bill_to_state,
          city_name: _self.bill_to_city_search
        })
        .then(function(res) {
          let data = res.data.data;
          if (res.data.status == true) {
            _self.bill_cities.push({ value: data.value, text: data.text });
            _self.form_data.bill_to_city = data.value;
            _self.changeCity2();
            _self.loading = false;
          } else {
            _self.form_error.bill_to_city = "City already exist";
            _self.loading = false;
          }
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    addCustomer() {
      this.$router.push({ path: "/customers" });
    },
    addUser() {
      this.$router.push({ path: "/users" });
    },
    addZip() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_zip", { zip_code: _self.zip_search })
        .then(function(res) {
          let data = res.data.data;
          _self.zip_items.push({ value: data.value, text: data.text });
          _self.form_data.p_zip = data.value;
          _self.new_zip_id = data.value;
          _self.getStates(false);
          _self.loading = false;
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    addZip2() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_zip", { zip_code: _self.bill_zip_search })
        .then(function(res) {
          let data = res.data.data;
          _self.bill_zip_items.push({ value: data.value, text: data.text });
          _self.form_data.bill_to_zip = data.value;
          _self.new_zip_id2 = data.value;
          _self.getStates(true);
          _self.loading = false;
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    addDomain() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_domain", { domain: _self.domain_search })
        .then(function(res) {
          let data = res.data.data;
          _self.domain_list.push({ value: data.domain_id, text: data.domain });
          _self.form_data.bill_to_email_domain = data.domain_id;
          _self.loading = false;
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    getEmailDomains() {
      axios.get("get_domains").then(response => {
        if (response.data.status) {
          this.domain_list = response.data.data;
        }
      });
    },
    changeCity() {
      if (this.form_data.p_zip == this.new_zip_id) {
        axios
          .post("zip_update", {
            state_id: this.form_data.p_state,
            zip_id: this.form_data.p_zip,
            city_id: this.form_data.p_city
          })
          .then(() => {})
          .catch(function() {});
      }

      this.zip_loading = true;
      axios
        .get("get_zip_by_city?city_id=" + this.form_data.p_city)
        .then(response => {
          if (response.data.status) {
            this.zip_items = response.data.data;
          }
        })
        .catch(function() {})
        .then(() => {
          this.zip_loading = false;
        });
    },
    changeCity2() {
      if (this.form_data.bill_to_zip == this.new_zip_id2) {
        axios
          .post("zip_update", {
            state_id: this.form_data.bill_to_state,
            zip_id: this.form_data.bill_to_zip,
            city_id: this.form_data.bill_to_city
          })
          .then(() => {})
          .catch(function() {});
      }

      this.bill_zip_loading = true;
      axios
        .get("get_zip_by_city?city_id=" + this.form_data.bill_to_city)
        .then(response => {
          if (response.data.status) {
            this.bill_zip_items = response.data.data;
          }
        })
        .catch(function() {})
        .then(() => {
          this.bill_zip_loading = false;
        });
    },
    getCustomers() {
      let _self = this;
      axios
        .get("customer_list?itemsPerPage=-1")
        .then(response => {
          _self.customer_list = response.data.data.data;
          console.log(_self.customer_list);
        })
        .catch(function() {});
    },
    saveProject() {
      this.loading = true;
      this.form_error = {};
      let _self = this;
      let serverData = JSON.parse(JSON.stringify(this._data.form_data));
      axios
        .post("add_project", serverData)
        .then(function(res) {
          _self.loading = false;
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.setData({ key: "add_modal", value: false });
          }
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    closePopup() {
      this.setData({ key: "add_modal", value: false });
    },
    getCity() {
      let _self = this;
      axios
        .get("get_city?state_id=" + this.form_data.p_state)
        .then(response => {
          if (response.data.status) {
            _self.cities = response.data.data;
          }
        })
        .catch(function() {});
    },
    getCity2() {
      let _self = this;
      axios
        .get("get_city?state_id=" + this.form_data.bill_to_state)
        .then(response => {
          if (response.data.status) {
            _self.bill_cities = response.data.data;
          }
        })
        .catch(function() {});
    },
    getUsers() {
      let _self = this;
      axios
        .get("user_list?itemsPerPage=-1")
        .then(response => {
          if (response.data.status) {
            _self.users = response.data.data.data;
          }
        })
        .catch(function() {});
    },
    getStates(forBill = false) {
      let _self = this;
      let zip = forBill ? this.form_data.bill_to_zip : this.form_data.p_zip;
      axios
        .get("get_states?zip=" + zip)
        .then(response => {
          if (response.data.status) {
            _self.state_list = response.data.data;
            //if (response.data.selection) {
            if (forBill) {
              this.bill_cities = response.data.selection.all_city;
              this.form_data.bill_to_state =
                response.data.selection.selected_state;
              this.form_data.bill_to_city =
                response.data.selection.selected_city;
            } else {
              this.cities = response.data.selection.all_city;
              this.form_data.p_state = response.data.selection.selected_state;
              this.form_data.p_city = response.data.selection.selected_city;
            }
            //}
          }
        })
        .catch(function() {});
    },
    fetchZipCodes() {
      this.zip_loading = true;
      axios
        .get("get_zip_suggestion?zip=" + this.zip_search)
        .then(response => {
          if (response.data.status) {
            this.zip_items = response.data.data;
          }
        })
        .catch(function() {})
        .then(() => {
          console.log("k");
          this.zip_loading = false;
        });
    },
    fetchBZipCodes() {
      this.bill_zip_loading = true;
      axios
        .get("get_zip_suggestion?zip=" + this.bill_zip_search)
        .then(response => {
          console.log(response);
          if (response.data.status) {
            this.bill_zip_items = response.data.data;
          }
          this.bill_zip_loading = false;
        })
        .catch(function() {})
        .then(() => {
          console.log("ok");
          this.bill_zip_loading = false;
        });
    },
    getInitalStates() {
      let _self = this;
      axios
        .get("get_states")
        .then(response => {
          if (response.data.status) {
            _self.state_list = response.data.data;
            _self.form_data.p_state = FLORIDA_STATE;
            _self.form_data.bill_to_state = FLORIDA_STATE;
          }
        })
        .catch(function() {});
    },
    disabledTypeValue() {
      this.form_data.p_type = "";
      this.form_data.p_price = "";
    },
    getNextProject() {
      let _self = this;
      axios
        .get("get_next_project")
        .then(response => {
          _self.form_data.project_id = response.data.next_project_id;
        })
        .catch(function() {});
    }
  },
  mounted: function() {
    if (this.add_modal) {
      this.getNextProject();
    }
  }
};
</script>
<style>
.project-radio-margin .v-input--selection-controls__input {
  margin-right: 16px !important;
}
</style>